// TODO
// - validation
// maybe move out /wizard const. Actually should all URIs be centralised?

import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import { PropTypes } from "prop-types";

import UnauthorisedFeature from "../../components/auth/UnauthorisedFeature.jsx";
import SimplePreloader from "../../components/preloaders/SimplePreloader.jsx";
import ScheduleForm from "../../components/schedules/ScheduleForm.jsx";
import RedirectWithReset from "../../components/utils/RedirectWithReset.jsx";

import { ROUTES } from "../../constants/routing.js";
import { AT_TYPES } from "../../constants/entity.js";
import { OPERATIONS } from "../../constants/operations.js";
import { MODES } from "../../components/forms/formConstants.js";

import { combineResourceArrays } from "../../state/reducers/schedules/scheduleUtils.js";

import {
  getSchedule,
  createSchedule,
  updateSchedule
} from "../../state/reducers/schedules/scheduleActions.js";
import { getProjects } from "../../state/reducers/projects/projectsActions.js";

import scheduleSelector from "../../state/reducers/schedules/scheduleSelector.js";
import { selectOperationAvailability } from "../../state/reducers/endpoints/endpointSelector.js";
import { selectLatestViolationErrors } from "../../state/reducers/api/apiSelectors.js";
import { selectCopy } from "../../state/reducers/locale/copySelector.js";

class Schedule extends Component {
  static propTypes = {
    isFetching: PropTypes.bool.isRequired,
    getSchedule: PropTypes.func.isRequired,
    schedule: PropTypes.object,
    listProjectAvailability: PropTypes.object.isRequired,
    createScheduleAvailability: PropTypes.object.isRequired,
    copy: PropTypes.func.isRequired
  };

  static WIZARD_URI = `${ROUTES.SCHEDULES}/wizard`;

  constructor(props) {
    super(props);

    this.state = {
      scheduleAtId: this.getScheduleAtId(),
      cancelSchedule: false
    };
  }

  componentDidMount = () => {
    const { getProjects, getSchedule, listProjectAvailability } = this.props;
    const { scheduleAtId } = this.state;

    // current quick way of determining whether this is a current schedule
    if (scheduleAtId && scheduleAtId !== Schedule.WIZARD_URI) {
      getSchedule(scheduleAtId);
    }

    // refresh projects data as it is required by the ResourcePicker
    if (listProjectAvailability.available) {
      getProjects("?pagination=false&order[name]=asc");
    }
  };

  static getDerivedStateFromProps = (props, state) => {
    const scheduleAtId = `${ROUTES.SCHEDULES}/${props.match.params.id}`;

    if (state.scheduleAtId !== scheduleAtId) {
      return { scheduleAtId };
    }

    return null;
  };

  // -- HELPERS -- //

  getScheduleAtId = () => {
    const { id } = this.props.match.params;
    return `${ROUTES.SCHEDULES}/${id}`;
  };

  // -- HANDLERS -- //

  onCancel = () => {
    this.setState({ cancelSchedule: true });
  };

  onSubmit = values => {
    const { scheduleAtId } = this.state;

    if (scheduleAtId && scheduleAtId !== Schedule.WIZARD_URI) {
      const data = {
        ...values,
        "@id": scheduleAtId
      };
      this.props.updateSchedule(scheduleAtId, data);
    } else {
      this.props.createSchedule(values);
    }
  };

  // -- RENDER -- //

  render() {
    const { scheduleAtId, cancelSchedule } = this.state;
    const {
      lastCreated,
      isFetching,
      schedule,
      violationErrors,
      createScheduleAvailability,
      listScheduleAvailability,
      copy
    } = this.props;

    // display unauthorised component if user diesn't have valid flags set
    if (!listScheduleAvailability.permitted) {
      return <UnauthorisedFeature title={copy("schedule.title")} />;
    }

    // redirect to the schedules page on cancellation action
    if (cancelSchedule) {
      return <RedirectWithReset to={ROUTES.SCHEDULES} />;
    }

    // redirect for freshly created schedule
    if (lastCreated && lastCreated !== scheduleAtId) {
      // return <RedirectWithReset to={lastCreated} />; // needs reimplementing once notification system is in place.
      return <RedirectWithReset to={ROUTES.SCHEDULES} />;
    }

    let parsedSchedule = null;
    if (schedule) {
      parsedSchedule = { ...schedule };
      parsedSchedule.resources = combineResourceArrays(schedule);
    }

    // set form mode
    let mode = MODES.READ;
    if (createScheduleAvailability.permitted === true) {
      mode =
        schedule && scheduleAtId !== Schedule.WIZARD_URI
          ? MODES.EDIT
          : MODES.CREATE;
    }

    return (
      <Fragment>
        {isFetching && <SimplePreloader />}

        <ScheduleForm
          key={`schedulePanel`}
          schedule={parsedSchedule}
          mode={mode}
          onReset={() => {}}
          onCancel={this.onCancel}
          onSubmit={this.onSubmit}
          violationErrors={violationErrors}
        />
      </Fragment>
    );
  }
}

const mapStateToProps = (state, props) => ({
  schedule: scheduleSelector.selectSchedule()(state, props),
  isFetching: state.schedules.isFetching,
  lastCreated: state.schedules.lastCreated,
  violationErrors: selectLatestViolationErrors(state),
  createScheduleAvailability: selectOperationAvailability(state)(
    AT_TYPES.SCHEDULE,
    OPERATIONS.CREATE
  ),
  listScheduleAvailability: selectOperationAvailability(state)(
    AT_TYPES.SCHEDULE,
    OPERATIONS.LIST
  ),
  listProjectAvailability: selectOperationAvailability(state)(
    AT_TYPES.PROJECT,
    OPERATIONS.LIST
  ),
  copy: selectCopy(state)
});

const mapDispatchToProps = dispatch => ({
  getProjects: (...args) => dispatch(getProjects(...args)),
  getSchedule: id => dispatch(getSchedule(id)),
  createSchedule: data => dispatch(createSchedule(data)),
  updateSchedule: (id, data) => dispatch(updateSchedule(id, data))
});

export default connect(mapStateToProps, mapDispatchToProps)(Schedule);
